import { render, staticRenderFns } from "./OrderDetailDrawer.vue?vue&type=template&id=ad72732c&"
import script from "./OrderDetailDrawer.vue?vue&type=script&lang=js&"
export * from "./OrderDetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderDetailDrawer.vue"
export default component.exports